import { render } from "./AutocompleteGenerico.vue?vue&type=template&id=51cffa3a&ts=true"
import script from "./AutocompleteGenerico.vue?vue&type=script&lang=ts"
export * from "./AutocompleteGenerico.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__